customElements.get("quick-add-modal") ||
  customElements.define(
    "quick-add-modal",
    class extends ModalDialog {
      constructor() {
        super(),
          (this.modalContent = this.querySelector('[id^="QuickAddInfo-"]'));
      }
      hide(e = !1) {
        const t = document.querySelector("cart-drawer");
        t && t.setActiveElement(this.openedBy),
          (this.modalContent.innerHTML = ""),
          e && (this.openedBy = null),
          super.hide();
      }
      show(e) {
        e.setAttribute("aria-disabled", !0),
          e.classList.add("loading"),
          e
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden"),
          fetch(e.getAttribute("data-product-url"))
            .then((e) => e.text())
            .then((t) => {
              const r = new DOMParser().parseFromString(t, "text/html");
              (this.productElement = r.querySelector(
                'section[id^="MainProduct-"]'
              )),
                this.preventDuplicatedIDs(),
                this.removeDOMElements(),
                this.setInnerHTML(
                  this.modalContent,
                  this.productElement.innerHTML
                ),
                window.Shopify &&
                  Shopify.PaymentButton &&
                  Shopify.PaymentButton.init(),
                window.ProductModel && window.ProductModel.loadShopifyXR(),
                this.removeGalleryListSemantic(),
                this.preventVariantURLSwitching(),
                super.show(e);
            })
            .finally(() => {
              e.removeAttribute("aria-disabled"),
                e.classList.remove("loading"),
                e
                  .querySelector(".loading-overlay__spinner")
                  .classList.add("hidden");
            });
      }
      setInnerHTML(e, t) {
        (e.innerHTML = t),
          e.querySelectorAll("script").forEach((e) => {
            const t = document.createElement("script");
            Array.from(e.attributes).forEach((e) => {
              t.setAttribute(e.name, e.value);
            }),
              t.appendChild(document.createTextNode(e.innerHTML)),
              e.parentNode.replaceChild(t, e);
          });
      }
      preventVariantURLSwitching() {
        this.modalContent
          .querySelector("variant-radios,variant-selects")
          .setAttribute("data-update-url", "false");
      }
      removeDOMElements() {
        const e = this.productElement.querySelector("pickup-availability");
        e && e.remove();
        const t = this.productElement.querySelector("product-modal");
        t && t.remove();
      }
      preventDuplicatedIDs() {
        const e = this.productElement.dataset.section;
        (this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(e, `quickadd-${e}`)),
          this.productElement
            .querySelectorAll("variant-selects, variant-radios")
            .forEach((t) => {
              t.dataset.originalSection = e;
            });
      }
      removeGalleryListSemantic() {
        const e = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        e &&
          (e.setAttribute("role", "presentation"),
          e
            .querySelectorAll('[id^="Slide-"]')
            .forEach((e) => e.setAttribute("role", "presentation")));
      }
    }
  );
